export default "__VITE_ASSET__DabJCrpl__"